import React, { useState, useContext, useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import PageNavigations from "../breadcrumbs/PageNavigations";
import StudentAddRelatedList from "./studentAddRelatedList";
import { usePermissions } from "../contexts/PermissionContext";
import { SessionContext } from "../SessionProvider";


const StudentAddmissionView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { rolePermissions, userInfo } = usePermissions();
  const canEdit = rolePermissions?.Students_Registration_List?.can_edit;
  const [studentaddmission, setStudentAddmission] = useState(location?.state ? location.state.student_info : []);
    const { selectedSessionId, setSelectedSessionId, currentSessionId } = useContext(SessionContext);
    const [isCurrentSession,setIsCurrentSession] = useState();
  

    useEffect(() => {
      async function init() {
        try {
          if (currentSessionId !== null && currentSessionId !== undefined) {
            setIsCurrentSession(selectedSessionId === currentSessionId);
          }
        } catch (error) {
          console.log('error=>', error);
        }
      }
      init();
    }, [selectedSessionId,isCurrentSession]);

  let msg = `Are you sure want to ${
    studentaddmission.active === true ? "Inactive" : "Active"
  } student`;

 
  const [modalShow, setModalShow] = useState(false);
  const [statusColor, setStatusColor] = useState("primary"); // For button color

  const handleCancel = async () => {
    navigate("/studentaddmissions");
  };

  const editStudent = () => {
    navigate(`/student/${studentaddmission.student_addmission_id}/e`, {
      state: location.state,
    });
  };

  const handleValueFromChild = (value) => {
    setStudentAddmission(value);
  };

  const handlePreviewClick = () => {
    const row = location?.state;
    navigate("/feedepositeedit/e", { state: { row } });
  };

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <PageNavigations
        listName="Admissions Details"
        listPath="/studentaddmissions"
        colLg={2}
        colClassName="d-flex mx-5 mb-4"
        extrColumn={12}
      />
      <div>
        {studentaddmission && (
          <Container>
            <Row className="view-form">
              <Col lg={12}>
                <Row className="view-form-header align-items-center mx-3">
                  <Col lg={8}>
                    <h5>
                      {studentaddmission?.studentname
                        ? studentaddmission.studentname
                        : studentaddmission.firstname +
                          " " +
                          studentaddmission.lastname}{" "}
                      ({studentaddmission.classname}{" "}
                      {studentaddmission.section_name})
                    </h5>
                  </Col>
                  <Col lg={4} className="d-flex justify-content-end">
                    {(canEdit ||
                      userInfo?.userrole === "SYS_ADMIN" ||
                      userInfo?.userrole === "ADMIN") && 
                    <Button className="btn-sm mr-2 mx-2" onClick={() => editStudent(true)} disabled={isCurrentSession === false?true:false}>
                      Edit Student Admission
                    </Button>
                    }

                    <Button
                      className="btn-sm mr-2 mx-2"
                      onClick={() => handlePreviewClick()}
                    >
                      Fee Deposit
                    </Button>
                    <Button
                      className="btn-sm"
                      variant="danger"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col></Col>
              <div className="px-4 mt-2">
                <StudentAddRelatedList
                  studentaddmission={studentaddmission}
                  onValueChange={handleValueFromChild}
                />
              </div>
            </Row>
          </Container>
        )}
      </div>
    </>
  );
};

export default StudentAddmissionView;
